
const initialState = (localStorage.getItem('subscriberDirectoryData')) ? JSON.parse(localStorage.getItem('subscriberDirectoryData')) : null;

export const subscriberDirectory = {
    namespaced: true,
    state: initialState,
    actions: {
        //first step to for identify host
        hostIdentification({ commit }, data) {
            commit('hostIdentificationState', data);
        },
        resetHostIdentification({ commit }) {
            commit('resetHostIdentificationState');

        },
        //second step to select group
        selectGroup({ commit }, data) {
            commit('selectGroupState', data);
        },
        resetSelectGroup({ commit }) {
            commit('resetSelectGroupState');
        },
        //third step to validate portal security code
        portalSecurityStatus({ commit }) {
            commit('portalSecurityState');
        },
        resetportalSecurityStatus({ commit }) {
            commit('resetPortalSecurityState');
        },

        //after successfull login
        LoggedinUserStatus({ commit }, userData) {
            commit('LoggedinUserState', userData);
        },

        //after successfull payment
        userPaymentStatus({ commit }) {
            commit('userPaymentStatus');
        },
    },
    mutations: {
        //first step to for identify host
        hostIdentificationState(state, data) {
            state.hostIdentificationData = data;
            localStorage.setItem('subscriberDirectoryData', JSON.stringify(state));

        },
        resetHostIdentificationState(state) {
            //this will make the subscriberDirectory object empty
            state.hostIdentificationData = null;
            state.groupSelected = null;
            state.portalSecurityStatus = null;
            state.subscriber = null;
            state.paymentStatus = null;
            localStorage.removeItem("subscriberDirectoryData");
        },

        //second step to select group
        selectGroupState(state, data) {
            state.groupSelected = data;
            localStorage.setItem('subscriberDirectoryData', JSON.stringify(state));

        },
        resetSelectGroupState(state) {
            state.groupSelected = null;
            state.portalSecurityStatus = null;
            state.subscriber = null;
            state.paymentStatus = null;
            localStorage.setItem('subscriberDirectoryData', JSON.stringify(state));
        },

        //third step validate portal security code
        portalSecurityState(state) {
            state.portalSecurityStatus = true;
            localStorage.setItem('subscriberDirectoryData', JSON.stringify(state));
        },
        resetPortalSecurityState(state) {
            state.portalSecurityStatus = null;
            state.subscriber = null;
            state.paymentStatus = null;
            localStorage.setItem('subscriberDirectoryData', JSON.stringify(state));
        },

        //final step after successfully login 
        LoggedinUserState(state, userData) {
            state.subscriber = userData;
            localStorage.setItem('subscriberDirectoryData', JSON.stringify(state));
        },

        // step after successfully payment 
        userPaymentStatus(state) {
            state.paymentStatus = 'done';
            localStorage.setItem('subscriberDirectoryData', JSON.stringify(state));
        },
    },

};